import './App.css';
import { useState, useRef, useEffect } from 'react'
import AppContent from './interfaces/AppContent';
import AppContext from './context/AppContext';
import AppRouter from './components/AppRouter';
import { User } from 'firebase/auth';
import { Interface } from './interfaces/Interface';
import ContactButton from './components/ContactButton';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<User>(Interface.emptyInterface<User>());
  
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const saveUser = (user: User) => {
    localStorage.setItem('user', JSON.stringify(user));
    setUser(user);
  };

  const addressRef = useRef<HTMLHeadingElement>(null);
  const details: AppContent = {
    isAuthenticated,
    setIsAuthenticated,
    user,
    setUser: saveUser,
    addressRef
  }
  return (
    <AppContext.Provider value={details}>
      <div className="App">
        <AppRouter />
        <ContactButton />
      </div>
    </AppContext.Provider>
  );
}

export default App;
